import React from 'react';

export const NotFound = ({page}) => (
  <div>
    <h1>The requested page /{page} is not available</h1>
  </div>
);
